import { RouteObject } from 'react-router-dom'

import PrivateRoute from 'component/common/private-route'
import { FEATURE } from 'constants/feature'
import AirDrop from 'pages/airdrop'
import CreateAirdrop from 'pages/airdrop/create'
import AirdropDetails from 'pages/airdrop/details'
import { PAGES } from 'routes/index'

export const airdropRoutes: RouteObject[] = [
  {
    path: PAGES.AIRDROP,
    element: (
      <PrivateRoute feature={FEATURE.AIRDROP}>
        <AirDrop />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.AIRDROP_CREATE,
    element: (
      <PrivateRoute feature={FEATURE.AIRDROP} requireCRUD>
        <CreateAirdrop />
      </PrivateRoute>
    ),
  },
  {
    path: PAGES.AIRDROP_DETAIL,
    element: (
      <PrivateRoute feature={FEATURE.AIRDROP}>
        <AirdropDetails />
      </PrivateRoute>
    ),
  },
]
